import { BaseResource } from '@/models/_base.model';
import { CarePlanFlat } from '@/models/care-plan.model';
import { CouponFlat } from '@/models/coupon.model';
import { PatientFlat } from '@/models/patient.model';
import { SubscriptionFlat } from '@/models/subscription.model';
import { UserFlatRelationship } from '@/models/user.model';

export enum InvoiceStatusEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  FAILED = 'failed',
  VOID = 'void'
}

export enum InvoicePaymentStatusEnum {
  IDLE = 'idle',
  PENDING = 'pending',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded'
}

export type InvoiceItem = {
  id: string;
  productId: string;
  title: string;
  qty: number;
  unitAmount: number;
};

export type InvoiceFlat = BaseResource & {
  accountId: string;
  patientId: string;
  subscriptionId: string | null;
  invoiceNumber: number;
  globalInvoiceNumber: string;
  status: InvoiceStatusEnum;
  paymentStatus: InvoicePaymentStatusEnum;

  total: number;
  subtotal: number;
  shippingAmount: number;
  carePlanAmount: number;
  totalCostAmount: number;
  processingFeeAmount: number;
  applicationFeeAmount: number;
  refundedAmount: number;
  discountAmount: number;
  isRefunded: boolean;
  isPartiallyRefunded: boolean;
  attemptCount: number;
  isOffCycle: boolean;
  periodStart: string | null;
  periodEnd: string | null;
  lastPaymentError: {
    code: string | null;
    declineCode: string | null;
    customerMessage: string | null;
    sellerMessage: string | null;
    failedAt: string | null;
  };
  items: InvoiceItem[];
  couponId: string | null;
  nextRetryAt: string | null;
  paidAt: string | null;
  fulfillmentInitiatedAt: string | null;
};

export type Invoice = InvoiceFlat & {
  patient: PatientFlat;
  assignee: UserFlatRelationship | null;
};

export type InvoiceFull = Invoice & {
  subscription: SubscriptionFlat | null;
  carePlan: CarePlanFlat | null;
  coupon: CouponFlat | null;
};
